// extracted by mini-css-extract-plugin
export default {"container":"RegisterForm_container__TX4Yv","actions":"RegisterForm_actions__jXGg2","formGroup":"RegisterForm_formGroup__702gB"};